import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

const FormularioUsuario = () => {
  const [formValues, setFormValues] = useState({
    id: 0,
    nombre: "",
    email: "",
    password: "desem",
    rol: "",
  });

  const navigate = useNavigate();

  const [mensajeError, setMensajeError] = useState(""); // Estado para el mensaje de error

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const registrarUsuario = async (e) => {
    e.preventDefault();

    try {
      const { nombre, apellido, telefono, email, cedulaIdentidad, rol } =
        formValues;
      const registro = {
        id: 0,
        nombre,
        apellido,
        telefono,
        email,
        password: "",
        rol,
        cedulaIdentidad,
      };

      let respuesta = await fetch(
        `https://pideapi2025.azurewebsites.net/api/Usuarios/crear`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            apiKey: localStorage.getItem("apiKey"),
          },
          body: JSON.stringify(registro),
        }
      );

      console.log(respuesta);

      if (respuesta.status === 200) {
        toast.success(
          "¡El usuario:" + registro.nombre + "se ha registrado con éxito!",
          {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
        navigate("/DashboardSoporte");

        setMensajeError(""); 
        setFormValues({
          nombre: "",
          email: "",
          rol: "",
        });
        console.log("Solicitud registrada con éxito");
      } else {
        console.error("Error al registrar la solicitud");
      }
    } catch (error) {
      console.error("Error en la solicitud", error);
      setMensajeError("Error en los datos." + error.mensajeError);
    }
  };

  return (
    <div
      className="container d-flex justify-content-center align-items-center"
      style={{ marginTop: "6rem" }}
    >
      <div className="w-100" style={{ maxWidth: "450px" }}>
        <h2 className="text-center mb-3" style={{ fontSize: "20px" }}>
          Registro Usuario
        </h2>
        <form
          onSubmit={registrarUsuario}
          className="border p-3 rounded bg-white shadow-sm"
          style={{ fontSize: "14px" }}
        >
          <div className="form-group mb-2">
            <label htmlFor="inputUsuarioNombre">Nombre</label>
            <input
              type="text"
              className="form-control"
              id="inputProgramaNombre"
              name="nombre"
              value={formValues.nombre}
              onChange={handleChange}
              placeholder="Nombre del Usuario"
              required
            />
          </div>
          <div className="form-group mb-2">
            <label htmlFor="inputUsuarioApellido">Apellido</label>
            <input
              type="text"
              className="form-control"
              id="inputUsuarioApellido"
              name="apellido"
              value={formValues.apellido}
              onChange={handleChange}
              placeholder="apellido"
              required
            />
          </div>
          <div className="form-group mb-2">
            <label htmlFor="inputUsuarioEmail">Email</label>
            <input
              type="text"
              className="form-control"
              id="inputUsuarioEmail"
              name="email"
              value={formValues.email}
              onChange={handleChange}
              placeholder="email"
              required
            />
          </div>
          <div className="form-group mb-2">
            <label htmlFor="inputUsuarioCi">Cédula</label>
            <input
              type="text"
              className="form-control"
              id="inputUsuariocedulaIdentidad"
              name="cedulaIdentidad"
              value={formValues.cedulaIdentidad}
              onChange={handleChange}
              placeholder="cédula"
              required
            />
          </div>
          <div className="form-group mb-2">
            <label htmlFor="inputUsuarioTelefono">Teléfono</label>
            <input
              type="text"
              className="form-control"
              id="inputUsuarioTelefono"
              name="telefono"
              value={formValues.telefono}
              onChange={handleChange}
              placeholder="Teléfono"
              required
            />
          </div>
          <div className="form-group mb-2">
            <label htmlFor="inputUsuarioRol">Rol</label>
            <select
              className="form-control"
              id="inputUsuarioRol"
              name="rol"
              value={formValues.rol || ""}
              onChange={handleChange}
              required
            >
              <option value="" disabled>
                Seleccione un rol
              </option>
              <option value="soporte">Soporte</option>
              <option value="coordinador">Coordinador</option>
              <option value="finanzas">Finanzas</option>
              <option value="comunicacion">Comunicación</option>
            </select>
          </div>

          <div className="d-flex justify-content-end">
            <button
              className="btn btnColorPrincipal form-control"
              type="submit"
            >
              {" "}
              Registrar{" "}
            </button>
          </div>
        </form>

        
        {mensajeError && (
          <div className="alert alert-danger mt-2" style={{ fontSize: "14px" }}>
            {mensajeError}
          </div>
        )}
      </div>
    </div>
  );
};

export default FormularioUsuario;
